module.exports = __webpack_public_path__ + "static/media/centri-cat3.173f2e37.png";